var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_03-wrong",
    "data-name": "03-wrong"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,54a1,1,0,0,1,0-2,4,4,0,0,0,4-4V22a4,4,0,0,0-4-4H32a5.459,5.459,0,0,1-4.076-1.83l-5.342-6.011A3.458,3.458,0,0,0,20,9H6a4,4,0,0,0-4,4V48a4,4,0,0,0,4,4H54a1,1,0,0,1,0,2H6a6.006,6.006,0,0,1-6-6V13A6.006,6.006,0,0,1,6,7H20a5.459,5.459,0,0,1,4.076,1.83l5.342,6.011A3.458,3.458,0,0,0,32,16H58a6.006,6.006,0,0,1,6,6V48A6.006,6.006,0,0,1,58,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,14a1,1,0,0,1-1-1,4,4,0,0,0-4-4H27a1,1,0,0,1,0-2H51a6.006,6.006,0,0,1,6,6A1,1,0,0,1,56,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.657,46.654a4.984,4.984,0,0,1-3.536-1.462L32,43.071l-2.121,2.121a5,5,0,1,1-7.071-7.07L24.929,36l-2.121-2.122a5,5,0,0,1,7.071-7.07L32,28.929l2.121-2.121a5,5,0,1,1,7.071,7.07L39.071,36l2.121,2.122a5,5,0,0,1-3.535,8.532Zm-5.657-6a1,1,0,0,1,.707.293l2.828,2.828a3,3,0,1,0,4.243-4.242L36.95,36.707a1,1,0,0,1,0-1.414l2.828-2.829a3,3,0,0,0-4.243-4.242L32.707,31.05a1.029,1.029,0,0,1-1.414,0l-2.828-2.828a3,3,0,1,0-4.243,4.242l2.828,2.829a1,1,0,0,1,0,1.414l-2.828,2.829a3,3,0,0,0,4.243,4.242l2.828-2.828A1,1,0,0,1,32,40.657Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/empty_folder.ba0a8657f3c7aa51748732dcb7d819af.svg";
export { ForwardRef as ReactComponent };